import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE,
  satContract: {}
};

const SwimAThonResultData = { INITIAL_STATE };

export default SwimAThonResultData;